/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminPostNotificationReqBodyDto } from '../../src/model';
// @ts-ignore
import type { CreateSystemNotificationNotFoundInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { CreateSystemNotificationNotFoundNotificationSendCategoryDto } from '../../src/model';
// @ts-ignore
import type { CreateSystemNotificationNotFoundNotificationStatusCategoryDto } from '../../src/model';
// @ts-ignore
import type { CreateSystemNotificationNotFoundNotificationTargetCategoryDto } from '../../src/model';
// @ts-ignore
import type { CreateSystemNotificationNotFoundUserDto } from '../../src/model';
// @ts-ignore
import type { DeleteNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { DeleteNotificationNotFoundDto } from '../../src/model';
// @ts-ignore
import type { DeleteNotificationReqBodyDto } from '../../src/model';
// @ts-ignore
import type { GetNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetNotificationOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchNotificationInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchNotificationNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchNotificationOkDto } from '../../src/model';
// @ts-ignore
import type { PatchNotificationReqBodyDto } from '../../src/model';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary v2에서 호출: 즉시 푸시 알림 생성
         * @param {AdminPostNotificationReqBodyDto} adminPostNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerCreateSystemNotification: async (adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPostNotificationReqBodyDto' is not null or undefined
            assertParamExists('notificationControllerCreateSystemNotification', 'adminPostNotificationReqBodyDto', adminPostNotificationReqBodyDto)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPostNotificationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알림 삭제
         * @param {DeleteNotificationReqBodyDto} deleteNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerDeleteNotification: async (deleteNotificationReqBodyDto: DeleteNotificationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteNotificationReqBodyDto' is not null or undefined
            assertParamExists('notificationControllerDeleteNotification', 'deleteNotificationReqBodyDto', deleteNotificationReqBodyDto)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteNotificationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 유저 시스템 알림 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {NotificationControllerGetNotificationSortEnum} [sort] 정렬 기준
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerGetNotification: async (page?: number, limit?: number, sort?: NotificationControllerGetNotificationSortEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 알림 상태 수정
         * @param {PatchNotificationReqBodyDto} patchNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerPatchNotification: async (patchNotificationReqBodyDto: PatchNotificationReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchNotificationReqBodyDto' is not null or undefined
            assertParamExists('notificationControllerPatchNotification', 'patchNotificationReqBodyDto', patchNotificationReqBodyDto)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchNotificationReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary v2에서 호출: 즉시 푸시 알림 생성
         * @param {AdminPostNotificationReqBodyDto} adminPostNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerCreateSystemNotification(adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerCreateSystemNotification(adminPostNotificationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationControllerCreateSystemNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알림 삭제
         * @param {DeleteNotificationReqBodyDto} deleteNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerDeleteNotification(deleteNotificationReqBodyDto: DeleteNotificationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerDeleteNotification(deleteNotificationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationControllerDeleteNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 유저 시스템 알림 조회
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {NotificationControllerGetNotificationSortEnum} [sort] 정렬 기준
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerGetNotification(page?: number, limit?: number, sort?: NotificationControllerGetNotificationSortEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotificationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerGetNotification(page, limit, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationControllerGetNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 알림 상태 수정
         * @param {PatchNotificationReqBodyDto} patchNotificationReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerPatchNotification(patchNotificationReqBodyDto: PatchNotificationReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchNotificationOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerPatchNotification(patchNotificationReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationControllerPatchNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary v2에서 호출: 즉시 푸시 알림 생성
         * @param {NotificationsApiNotificationControllerCreateSystemNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerCreateSystemNotification(requestParameters: NotificationsApiNotificationControllerCreateSystemNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationControllerCreateSystemNotification(requestParameters.adminPostNotificationReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알림 삭제
         * @param {NotificationsApiNotificationControllerDeleteNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerDeleteNotification(requestParameters: NotificationsApiNotificationControllerDeleteNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationControllerDeleteNotification(requestParameters.deleteNotificationReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 유저 시스템 알림 조회
         * @param {NotificationsApiNotificationControllerGetNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerGetNotification(requestParameters: NotificationsApiNotificationControllerGetNotificationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetNotificationOkDto> {
            return localVarFp.notificationControllerGetNotification(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 알림 상태 수정
         * @param {NotificationsApiNotificationControllerPatchNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerPatchNotification(requestParameters: NotificationsApiNotificationControllerPatchNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchNotificationOkDto> {
            return localVarFp.notificationControllerPatchNotification(requestParameters.patchNotificationReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notificationControllerCreateSystemNotification operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationControllerCreateSystemNotificationRequest
 */
export interface NotificationsApiNotificationControllerCreateSystemNotificationRequest {
    /**
     * 
     * @type {AdminPostNotificationReqBodyDto}
     * @memberof NotificationsApiNotificationControllerCreateSystemNotification
     */
    readonly adminPostNotificationReqBodyDto: AdminPostNotificationReqBodyDto
}

/**
 * Request parameters for notificationControllerDeleteNotification operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationControllerDeleteNotificationRequest
 */
export interface NotificationsApiNotificationControllerDeleteNotificationRequest {
    /**
     * 
     * @type {DeleteNotificationReqBodyDto}
     * @memberof NotificationsApiNotificationControllerDeleteNotification
     */
    readonly deleteNotificationReqBodyDto: DeleteNotificationReqBodyDto
}

/**
 * Request parameters for notificationControllerGetNotification operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationControllerGetNotificationRequest
 */
export interface NotificationsApiNotificationControllerGetNotificationRequest {
    /**
     * 현재 페이지
     * @type {number}
     * @memberof NotificationsApiNotificationControllerGetNotification
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof NotificationsApiNotificationControllerGetNotification
     */
    readonly limit?: number

    /**
     * 정렬 기준
     * @type {'latest' | 'unread'}
     * @memberof NotificationsApiNotificationControllerGetNotification
     */
    readonly sort?: NotificationControllerGetNotificationSortEnum
}

/**
 * Request parameters for notificationControllerPatchNotification operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationControllerPatchNotificationRequest
 */
export interface NotificationsApiNotificationControllerPatchNotificationRequest {
    /**
     * 
     * @type {PatchNotificationReqBodyDto}
     * @memberof NotificationsApiNotificationControllerPatchNotification
     */
    readonly patchNotificationReqBodyDto: PatchNotificationReqBodyDto
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary v2에서 호출: 즉시 푸시 알림 생성
     * @param {NotificationsApiNotificationControllerCreateSystemNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerCreateSystemNotification(requestParameters: NotificationsApiNotificationControllerCreateSystemNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerCreateSystemNotification(requestParameters.adminPostNotificationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알림 삭제
     * @param {NotificationsApiNotificationControllerDeleteNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerDeleteNotification(requestParameters: NotificationsApiNotificationControllerDeleteNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerDeleteNotification(requestParameters.deleteNotificationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 유저 시스템 알림 조회
     * @param {NotificationsApiNotificationControllerGetNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerGetNotification(requestParameters: NotificationsApiNotificationControllerGetNotificationRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerGetNotification(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 알림 상태 수정
     * @param {NotificationsApiNotificationControllerPatchNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerPatchNotification(requestParameters: NotificationsApiNotificationControllerPatchNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerPatchNotification(requestParameters.patchNotificationReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const NotificationControllerGetNotificationSortEnum = {
    Latest: 'latest',
    Unread: 'unread'
} as const;
export type NotificationControllerGetNotificationSortEnum = typeof NotificationControllerGetNotificationSortEnum[keyof typeof NotificationControllerGetNotificationSortEnum];
